import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    ACCOUNT_BY_ID,
    ACCOUNT_LIST,
    SAVE,
    SAVE_ACTIVITY,
    ACCOUNT_FILTER,
    PENDING_ACTIVITY,
    EXISTING_SITES,
    SITE_VISIT,
    SITE_VISIT_LIST,
    OPERATION_PROJECT_BY_ID,
    VALET_MOM,
    VALET_MOM_LIST,
    VALET_MOM_BY_ID, EXTERNAL_MOM_LIST
} from "./type";


export const saveAccount = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.valetAccountSave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE,
            payload: data.response,
        });
        return true;
    }
};

export const accountList = (page = 1, searchKey = '', data=[{}]) => async (dispatch) => {
    let urls = `${Config.valetAccountList}?page=` + page

    const search = window.localStorage.search_account
    if(search){
        searchKey = search
    }

    if(searchKey !== ''){
        urls = urls+"&search_key="+searchKey
    }
    Object.keys(data[0]).map((val, i)=>{
        urls+="&"+val+"="+data[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        urls
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACCOUNT_LIST,
            payload: data.response.data,
        });
        return true;
    }
};

export const accountById = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.valetAccountById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACCOUNT_BY_ID,
            payload: data.response,
        });
        return true;
    }
};

export const saveActivity = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.valetActivitySave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.valetAccountFilter}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACCOUNT_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const getPendingActivity = (accountId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.valetPendingActivity}?account_id=${accountId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const getExistingSites = (page='', name='', project_id='') => async (dispatch) => {
    const search = window.localStorage.search_account
    if(search){
        name = search
    }

    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.existingSite}?page=${page}&name=${name}&valet_project_id=${project_id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: EXISTING_SITES,
            payload: data.response?.data,
        });
        return true;
    }
};

export const saveSiteVisit = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.siteVisitValet}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_VISIT,
            payload: data.response,
        });
        return true;
    }
};

export const siteVisitList = (page, projectId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.siteVisitValetList}?page=${page}&valet_project_id=${projectId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_VISIT_LIST,
            payload: data.response?.data,
        });
        return true;
    }
};

export const valetOperationProject = (projectId) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.valetOperationProjectById}?valet_project_id=${projectId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OPERATION_PROJECT_BY_ID,
            payload: data.response?.data,
        });
        return true;
    }
};

export const createAndSendMom = (requestData) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        requestData,
        Config.meetingMomSend
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: VALET_MOM,
            payload: data.response,
        });
        return true;
    }
};

export const momListRequest = (page, meetingId, moduleType) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.momList}?page=${page}&meeting_id=${meetingId}&module_type=${moduleType}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: VALET_MOM_LIST,
            payload: data.response?.data,
        });
        return true;
    }
};

export const momByIdRequest = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.momById}?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: VALET_MOM_BY_ID,
            payload: data.response?.data,
        });
        return true;
    }
};

export const externalMomListRequest = (page, moduleType, filter = [{}]) => async (dispatch) => {
    let  urls = `${Config.externalMomList}?page=${page}&module_type=${moduleType}`;
    Object.keys(filter[0]).map((val, i)=>{
        urls+="&"+val+"="+filter[0][val]
    })
    const res = await callWebService(
        callTypes.get,
        '',
        `${urls}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: EXTERNAL_MOM_LIST,
            payload: data.response?.data,
        });
        return true;
    }
};